import React, { useState } from 'react';
import styled from 'styled-components';
import { colors, sizes, helpers, media } from 'styles/variables';

export default props => {
	const lang = props.pageContext.lang || '';
	const [testimonials] = useState(require(`data/${lang}_testimonials`));
	const Wrapper = styled.div`
		display: grid;
		${media.notsmall} {
			grid-template-columns: repeat(2, 1fr);
		}
		${media.small} {
			grid-template-columns: 100%;
		}
		grid-gap: ${sizes[2]};
	`;
	const Item = styled.div`
		background: ${colors.background[0]};
		border-radius: ${sizes[0]};
		${helpers.shadow};
		display: grid;
		grid-gap: ${sizes[2]};
		grid-template-rows: 1fr auto;
		text-align: left;
		padding: ${sizes[3]};
		position: relative;
		.publisher {
			position: absolute;
			bottom: calc(${sizes[2]} + 10px);
			right: ${sizes[2]};
			width: 30%;
			// filter: grayscale(1);
			// opacity: 0.5;
			${media.small} {
				display: none;
			}
		}
	`;
	const Text = styled.div`
		p {
			font-size: 1.1rem;
			line-height: 150%;
			color: ${colors.foreground[1]};
		}
	`;
	const Profile = styled.div`
		display: grid;
		grid-template-areas:
			'image name'
			'image date';
		grid-template-columns: auto 1fr;
		strong {
			grid-area: name;
			align-self: end;
		}
		small {
			grid-area: date;
			align-self: start;
		}
		div {
			grid-area: image;
			padding-right: ${sizes[1]};
			img {
				width: 50px;
				height: 50px;
				border-radius: 50px;
			}
		}
	`;
	return (
		<>
			<Wrapper>
				{testimonials.map((item, index) => (
					<Item key={index}>
						<Text>
							<p>“{item.text}”</p>
						</Text>
						<Profile>
							<div>
								<img alt={item.person} src={item.image.url} />
							</div>
							<strong>{item.person}</strong>
							<a href={item.link}>
								<small>{item.subtitle}</small>
							</a>
							<img className="publisher" src={item.publisher.url} alt="publisher logo" />
						</Profile>
					</Item>
				))}
			</Wrapper>
		</>
	);
};
